<template>
  <div>
    Evasive scenarios corresponding to optimal solutions are depicted as a
    trade-off between the displayed optimization criteria.
    <br />
    Depending on the features selected as inputs, the following objectives are
    considered :

    <br />
    <br />
    <b>Conjunction avoidance case : </b>
    <ul>
      <li>
        <b>Evasive (+ Chaser reaction)</b> : DeltaV / Target reaction duration /
        Minimum approach distance.
      </li>
      <li>
        <b>Evasive + Service recovery (+ Chaser reaction)</b> : DeltaV / Target
        service loss duration / Minimum approach distance.
      </li>
    </ul>

    <br />

    <b>RPO escape case : </b>
    <ul>
      <li>
        <b>Evasive (+ Chaser reaction)</b> : DeltaV / Target reaction duration /
        Escape date.
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipEvasiveSolutions'
}
</script>
